$ = require 'jquery'
Auth = require 'db/auth'
template = require 'views/templates/board_menu_about_this_board'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
View = require 'view'
PopOver = require 'views/lib/pop-over'
MemberMiniProfileView = require 'views/member-menu-profile/member-mini-profile-view'
MemberOnBoardView = require 'views/member-menu-profile/member-on-board-view'
AboutThisBoardAdminListView = require 'views/board-menu/about-this-board-admin-list-view'

module.exports = class BoardMenuAboutThisBoardView extends View
  viewTitleKey: 'about-this-board'

  className: 'board-menu-content-frame'

  events:
    'click .js-change-permissions': 'changePermissions'
    'click .js-fill-board-admin-count': 'openAllMembers'

  initialize: ({ @sidebarView }) ->
    super
    @makeDebouncedMethods 'render'

    @listenTo @model,
      'change:memberships': @renderDebounced
      'change:prefs.voting': @renderDebounced
      'change:prefs.comments': @renderDebounced

  getPermissionsLevelHeader: (level) ->
    switch level
      when 'members' then 'members-can'
      when 'observers' then 'members-and-observers-can'
      when 'org' then 'team-members-can'
      when 'public' then 'any-trello-user-can'

  getPermissionsHierarchy: (commentLevel, votingLevel) ->
    if commentLevel == votingLevel
      'equal'
    else if commentLevel != 'disabled' && votingLevel == 'disabled'
      'comment'
    else if commentLevel == 'disabled' && votingLevel != 'disabled'
      'voting'
    else
      hierarchy = ['members', 'observers', 'org', 'public']
      if hierarchy.indexOf(commentLevel) < hierarchy.indexOf(votingLevel)
        'comment'
      else
        'voting'

  render: ->
    isLoggedIn = Auth.isLoggedIn()
    me = Auth.me()

    data = {}
    data.isLoggedIn = Auth.isLoggedIn()
    data.isAdmin = @model.ownedByMember(me)

    if data.isAdmin
      # what users at all levels can see
      commentLevel = @model.getCommentPerm()
      votingLevel = @model.getPref('voting')
      data.canComment = commentLevel != 'disabled'
      data.canVote = votingLevel != 'disabled'
      data.commentHeader = @getPermissionsLevelHeader(commentLevel)
      data.votingHeader = @getPermissionsLevelHeader(votingLevel)
      data.permissionsHierarchy = @getPermissionsHierarchy(commentLevel, votingLevel)
    else if isLoggedIn
      # what you can see as a Trello member
      data.canComment = @model.canComment(me)
      data.canVote = @model.canVote(me)
    else
      # what logged-out users can see
      data.canComment = @model.getCommentPerm() == 'public'
      data.canVote = @model.getPref('voting') == 'public'

    @$el.html template(data)

    if @model.adminList.length == 1
      @renderSingleAdminProfile()

    else
      @renderMultiAdminAvatar()

    @

  renderSingleAdminProfile: ->
    admin = @model.adminList.models[0]
    data = admin.toJSON()
    data.showEmail = false
    data.isMe = admin == Auth.me()
    $target = @$('.js-made-by')

    if admin
      @$('.js-fill-board-admin-count').text('')

    miniProfileSubview = @subview(MemberMiniProfileView, admin)
    @ensureSubview(miniProfileSubview, $target)

  renderMultiAdminAvatar: ->
    $target = @$('.js-made-by-multi')
    visibleAdmins = @model.orderedVisibleAdmins()
    numAdmins = visibleAdmins.length
    visibleAdminList = visibleAdmins.slice(0, 5)

    if visibleAdminList.length < 5
      @$('.js-fill-board-admin-count').text('')
    else
      @$('.js-fill-board-admin-count').text(numAdmins)
      @$('.js-fill-board-admin-count').toggleClass('pile', numAdmins < 100)
      @$('.js-fill-board-admin-count').toggleClass('pile-lg', numAdmins >= 100)

    subviews = for admin in visibleAdminList
      @subview(MemberOnBoardView, admin, { board: @model })

    if $target.length
      @ensureSubviews(subviews, $target)

  openAllMembers: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-fill-board-admin-count')
      maxWidth: 304
      view: AboutThisBoardAdminListView
      options: {
        @model,
        @modelCache
      }

  changePermissions: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'settings'
    trackUe('board sidebar', 'opens', 'settings view', '', '', 'from about this board view', { boardId: @model.id })
    return


// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-menu-about-this-board-view.coffee